var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 268,
    viewBox: "0 0 269 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7165_2153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.5 241C196.08 241 246 191.08 246 129.5C246 67.9202 196.08 18 134.5 18C72.9202 18 23 67.9202 23 129.5C23 191.08 72.9202 241 134.5 241Z",
    fill: "white",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 129.5C243 189.423 194.423 238 134.5 238C74.5771 238 26 189.423 26 129.5C26 69.5771 74.5771 21 134.5 21C194.423 21 243 69.5771 243 129.5Z",
    stroke: "#E9E9E9",
    strokeWidth: 6,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7165_2153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.068 150.747L107.237 140.915C106.734 140.4 106.027 140.137 105.31 140.197C104.597 140.249 103.942 140.608 103.515 141.181L76.4937 178.048C75.6792 179.134 75.8993 180.675 76.9852 181.489C77.8592 182.145 79.0607 182.145 79.9347 181.489L116.802 154.453C117.897 153.651 118.135 152.113 117.333 151.018C117.258 150.917 117.177 150.821 117.088 150.732L117.068 150.747Z",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.02 133.542L124.442 108.963C120.307 105.744 115.155 104.113 109.921 104.367C103.069 104.127 96.4118 106.672 91.4672 111.421C87.4755 115.413 87.8885 121.582 92.696 129.762C97.2363 136.881 102.598 143.441 108.672 149.306C118.449 159.079 130.793 169.234 139.788 169.234C142.324 169.299 144.773 168.313 146.557 166.511C156.792 156.282 154.24 138.767 149.02 133.542Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.683 113.879L144.104 89.3005C143.145 88.341 141.589 88.341 140.629 89.3005L120.966 108.963C117.751 112.178 118.017 119.286 128.34 129.643C135.079 136.383 140.452 138.836 144.266 138.836C146.032 138.898 147.747 138.242 149.02 137.017L168.683 117.354C169.642 116.395 169.642 114.839 168.683 113.879Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.792 107.307C193.412 106.387 192.516 105.788 191.521 105.788C186.192 105.788 174.493 100.026 166.225 91.7584C157.957 83.4903 152.196 71.7957 152.196 66.4623C152.198 65.1049 151.099 64.0025 149.742 64C149.088 63.9989 148.46 64.2588 147.998 64.7221C137.96 74.7649 134.824 91.8911 150.455 107.523C156.402 114.132 164.773 118.049 173.657 118.382C181.047 118.297 188.099 115.274 193.256 109.981C193.958 109.28 194.17 108.225 193.792 107.307Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.514 79.4692C168.103 69.0626 158.689 64.0044 149.738 64.0044C148.38 64.0044 147.28 65.1049 147.28 66.4623C147.28 73.8015 154.221 86.7101 162.745 95.2387C171.268 103.767 184.187 110.704 191.521 110.704C192.878 110.704 193.979 109.603 193.979 108.246C193.979 99.2893 188.921 89.8756 178.514 79.4692Z",
    fill: "#F44336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7165_2153",
    x: 0.699997,
    y: 0.159997,
    width: 267.6,
    height: 267.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.46
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7165_2153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7165_2153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7165_2153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117.981,
    height: 117.981,
    fill: "white",
    transform: "translate(76 64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.64f5c941cbfe4cd4011d3b4f06ab33e4.svg";
export { ForwardRef as ReactComponent };